/**
 * MinMaxify in pagina prodotto.
 * L'app scrive min/max/step sull'input quantità, ma i pulsanti +/- del tema
 * ignorano quei valori e il carrello usa la quantità salvata dal tema.
 * Qui i limiti del formato selezionato vengono applicati alla quantità del
 * tema (valore iniziale, +/- a multipli, valore digitato).
 * Se il prodotto non ha limiti, i pulsanti restano quelli del tema.
 */
(function () {
  var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
  if (!match) return;

  var product = null;
  var lastVariant = null;

  function quantities() {
    return Array.prototype.filter.call(document.querySelectorAll('xo-cart-quantity'), function (el) {
      return !el.closest('xo-cart-mini') && !el.closest('xo-cart');
    });
  }

  function currentVariantId() {
    var input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    var id = input && Number(input.value);
    if (id) return id;
    var param = new URLSearchParams(window.location.search).get('variant');
    if (param) return Number(param);
    return product && product.variants[0] ? product.variants[0].id : 0;
  }

  function limits() {
    var none = { min: 1, step: 1, max: 0, active: false };
    var mm = window.minMaxify;
    if (!product || !mm || typeof mm.getLimitsFor !== 'function') return none;
    var id = currentVariantId();
    var variant = product.variants.filter(function (v) {
      return v.id === id;
    })[0];
    if (!variant) return none;
    var l =
      mm.getLimitsFor({
        variant_id: variant.id,
        sku: variant.sku || '',
        product_id: product.id,
        handle: product.handle,
        product_title: product.title,
        title: product.title,
        price: variant.price,
        grams: variant.weight
      }) || {};
    var step = l.combine ? 1 : Number(l.multiple) || 1;
    var min = Math.max(1, Number(l.min) || 1);
    var max = Number(l.max) || 0;
    return { min: min, step: step, max: max, active: min > 1 || step > 1 || max > 0 };
  }

  function snap(value, lim) {
    var v = Math.max(lim.min, Number(value) || lim.min);
    if (lim.step > 1) v = Math.ceil(v / lim.step) * lim.step;
    if (lim.max && v > lim.max) v = Math.floor(lim.max / lim.step) * lim.step;
    return Math.max(lim.min, v);
  }

  function setValue(input, value) {
    input.value = String(value);
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }

  // Scrive solo se cambia: apply() gira ogni 500ms e nell'editor ogni mutazione costa.
  function setAttr(el, name, value) {
    if (value === null) {
      if (el.hasAttribute(name)) el.removeAttribute(name);
    } else if (el.getAttribute(name) !== String(value)) {
      el.setAttribute(name, value);
    }
  }

  function applyAttributes(box, lim) {
    var input = box.querySelector('input[name="quantity"]');
    if (!input) return null;
    if (lim.active) {
      setAttr(box, 'xo-min', lim.min);
      setAttr(box, 'xo-step', lim.step);
      setAttr(box, 'xo-max', lim.max || null);
      setAttr(input, 'min', lim.min);
      setAttr(input, 'step', lim.step);
    }
    return input;
  }

  function apply() {
    var id = currentVariantId();
    if (!id) return;
    var lim = limits();
    var changed = id !== lastVariant;
    quantities().forEach(function (box) {
      var input = applyAttributes(box, lim);
      if (!input) return;
      if (changed) {
        if (lim.active) setValue(input, lim.min);
        else if (lastVariant !== null && Number(input.value) !== 1) setValue(input, 1);
      } else if (lim.active && Number(input.value) < lim.min && document.activeElement !== input) {
        setValue(input, lim.min);
      }
    });
    if (window.minMaxify && product) lastVariant = id;
  }

  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest('xo-cart-quantity-plus, xo-cart-quantity-minus');
      if (!button) return;
      var box = button.closest('xo-cart-quantity');
      if (!box || box.closest('xo-cart-mini') || box.closest('xo-cart')) return;
      var lim = limits();
      if (!lim.active) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      var input = box.querySelector('input[name="quantity"]');
      if (!input) return;
      var qty = snap(input.value, lim);
      var next = button.localName === 'xo-cart-quantity-plus' ? qty + lim.step : qty - lim.step;
      if (lim.max && next > lim.max) next = qty;
      if (next < lim.min) next = lim.min;
      quantities().forEach(function (other) {
        var el = other.querySelector('input[name="quantity"]');
        if (el) setValue(el, next);
      });
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      var input = event.target;
      if (!input || input.name !== 'quantity') return;
      var box = input.closest('xo-cart-quantity');
      if (!box || box.closest('xo-cart-mini') || box.closest('xo-cart')) return;
      var lim = limits();
      if (!lim.active) return;
      var v = snap(input.value, lim);
      if (String(v) !== input.value) setValue(input, v);
    },
    true
  );

  fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'products/' + match[1] + '.js', {
    headers: { Accept: 'application/json' }
  })
    .then(function (res) {
      return res.ok ? res.json() : null;
    })
    .then(function (data) {
      if (!data || !data.variants) return;
      product = data;
      apply();
      window.setInterval(apply, 500);
    })
    .catch(function () {});
})();
